import styled from 'styled-components';
import { Grid, Heading, Input } from '@dexma/ui-components';

export type HomeHeaderProps = {
    $showAlert: boolean;
};

export const StyledHomeGrid = styled(Grid)<HomeHeaderProps>`
    padding: 0px 30px 30px 30px;
    height: 100%;
    overflow: auto;
    .heading {
        padding: 20px 0px;
        align-items: baseline;
    }
    .ant-table-thead > tr > th {
        border-top: 0px;
    }
`;

export const StyledHeading = styled(Heading)`
    display: flex;
    align-items: center;

    button {
        margin-left: 10px;
    }
`;

export const StyledInputSearchBar = styled(Input)`
    .icon-container {
        width: auto;
    }
`;
